export enum EDataGridView {
  Values = 'values',
  Resources = 'resources',
}
